import Vue from 'vue'
import VueRouter from 'vue-router'
import Help from '../views/Help.vue'
import HelpDetail from '../views/HelpDetail.vue'
import CommonInfor from '../views/CommonInfor.vue'
import AddInfor from '../views/AddInfor.vue'
import CommonAddr from '../views/CommonAddr.vue'
import PlusAddr from '../views/PlusAddr.vue'
import CardUseHelp from '../views/CardUseHelp.vue'
import NFCCard from '../views/NFCCard.vue'
import Fabu from '../views/Fabu.vue'
import PrivacyContract from '../views/PrivacyContract.vue'
import UserContract from '../views/UserContract.vue'
import CityList from '../views/CityList.vue'
import BusCardDesc from '../views/BusCardDesc.vue'
import OldNew from '../views/OldNew.vue'
import GonggaoList from '../views/GonggaoList.vue'
import InforList from '../views/InforList.vue'
import CuowuPage from '../views/CuowuPage.vue'
import Fankui from '../views/Fankui.vue'
import FankuiTips from '../views/FankuiTips.vue'
import ByCarUseHelp from '../views/ByCarUseHelp.vue'
import IDcard from '../views/IDcard.vue'
import NewPatch from '../views/NewPatch.vue'
import Authercitation from '../views/Authercitation.vue'
import Saoyisao from '../views/Saoyisao.vue'
import ChangeInfor from '../views/ChangeInfor.vue'
import ChangeAddr from '../views/ChangeAddr.vue'
import Map1 from '../views/Map1.vue'
import Map2 from '../views/Map2.vue'
import Map3 from '../views/Map3.vue'
import HukouView from '../views/HukouView.vue'
import Fangchan from '../views/Fangchan.vue'
import ChongzhiTips from '../views/ChongzhiTips.vue'
import NFCliucheng from '../views/NFCliucheng.vue'
import JiaotongGonggao from '../views/JiaotongGonggao.vue'
import Weihu from '../views/Weihu.vue'
import ZhenjianView2 from '../views/ZhenjianView2.vue'
import YiqingGonggao from '../views/YiqingGonggao.vue'
import YimiaoDiaocha from '../views/YimiaoDiaocha.vue'
import NoContent from '../views/NoContent.vue'
import UnderMaintenance from '../views/UnderMaintenance.vue'
import H5toApp from '../views/H5toApp.vue'
// 积分规则
import IntegralRule from '../views/MyIntergral/components/IntegralRule.vue'
Vue.use(VueRouter)

const routes = [


  {
    path: '/',
    name: 'Hudong',
    // component: Hudong,
    component: () => import( /* webpackChunkName: "about" */ '../views/Hudong.vue'),
    meta: {
      title: '互动',
      keepAlive: false,
    }
  },
  {
    path: '/help',
    name: 'Help',
    component: Help,
    meta: {
      title: '帮助'
    }
  },
  {
    path: '/H5toApp',
    name: 'H5toApp',
    component: H5toApp,
    meta: {
      title: '跳转应用页'
    }
  },
  {
    path: '/UnderMaintenance',
    name: 'UnderMaintenance',
    component: UnderMaintenance,
    meta: {
      title: '维护中'
    }
  },
  {
    path: '/NoContent',
    name: 'NoContent',
    component: NoContent,
    meta: {
      title: '查询结果'
    }
  },
  {
    path: '/YimiaoDiaocha',
    name: 'YimiaoDiaocha',
    component: YimiaoDiaocha,
    meta: {
      title: '疫苗接种调查'
    }
  },
  {
    path: '/YiqingGonggao',
    name: 'YiqingGonggao',
    component: YiqingGonggao,
    meta: {
      title: '疫情通报'
    }
  },
  {
    path: '/ZhenjianView2',
    name: 'ZhenjianView2',
    component: ZhenjianView2,
    meta: {
      title: '证件查看'
    }
  },
  {
    path: '/Weihu',
    name: 'Weihu',
    component: Weihu,
    meta: {
      title: '系统提示'
    }
  },
  {
    path: '/JiaotongGonggao',
    name: 'JiaotongGonggao',
    component: JiaotongGonggao,
    meta: {
      title: '交通公告'
    }
  },
  {
    path: '/CuowuPage',
    name: 'CuowuPage',
    component: CuowuPage,
    meta: {
      title: '错误页面'
    }
  },
  {
    path: '/NFCliucheng',
    name: 'NFCliucheng',
    component: NFCliucheng,
    meta: {
      title: 'NFC充值流程'
    }
  },
  {
    path: '/helpDetail',
    name: 'HelpDetail',
    component: HelpDetail,
    meta: {

      title: '帮助详情'
    }
  },

  {
    path: '/serviceAddr',
    name: 'ServiceAddr',

    component: () => import( /* webpackChunkName: "about" */ '../views/ServiceAddr.vue'),
    meta: {
      title: '服务网点'
    }
  },
  {
    path: '/commonInfor',
    name: 'CommonInfor',
    component: CommonInfor,
    meta: {

      title: '常用信息'
    }
  },
  {
    path: '/addInfor',
    name: 'AddInfor',
    component: AddInfor,
    meta: {

      title: '常用信息'
    }

  },
  {
    path: '/commonAddr',
    name: 'CommonAddr',
    component: CommonAddr,
    meta: {

      title: '常用地址'
    }

  },
  {
    path: '/plusAddr',
    name: 'PlusAddr',
    component: PlusAddr,
    meta: {

      title: '添加地址'
    }
  },
  {
    path: '/budengji',
    name: 'Budengji',
    component: () => import( /* webpackChunkName: "about" */ '../views/Budengji.vue'),
    meta: {

      title: '补登记'
    }
  },
  {
    path: '/CardUseHelp',
    name: 'CardUseHelp',
    component: CardUseHelp,
    meta: {

      title: '卡片帮助'
    }
  },
  {
    path: '/nfccard',
    name: 'NFCCard',
    component: NFCCard,
    meta: {

      title: 'NFC卡片'
    }
  },
  {
    path: '/fabu',
    name: 'Fabu',
    component: Fabu,
    meta: {

      title: '发布'
    }
  },

  {
    path: '/myzone',
    name: 'Myzone',

    component: () => import( /* webpackChunkName: "about" */ '../views/Myzone.vue'),
    meta: {
      title: '我的空间'
    }
  },
  {
    path: '/hudongSearch',
    name: 'HudongSearch',
    component: () => import( /* webpackChunkName: "about" */ '../views/HudongSearch.vue'),
    meta: {
      title: '互动搜索'
    }
  },
  {
    path: '/fabuXiangqing',
    name: 'FabuXiangqing',
    component: () => import( /* webpackChunkName: "about" */ '../views/FabuXiangqing.vue'),
    meta: {
      title: '空间详情'
    }
  },
  {
    path: '/privacyContract',
    name: 'PrivacyContract',
    component: PrivacyContract,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/userContract',
    name: 'UserContract',
    component: UserContract,

    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/cardTotal',
    name: 'CardTotal',
    component: () => import( /* webpackChunkName: "about" */ '../views/CardTotal.vue'),
    meta: {
      title: '卡片'
    }
  },
  {
    path: '/cityList',
    name: 'CityList',
    component: CityList,
    meta: {
      title: '城市列表'
    }

  },
  {
    path: '/busCardDesc',
    name: 'BusCardDesc',
    component: BusCardDesc,
    meta: {
      title: '卡片介绍'
    }
  },
  {
    path: '/oldNew',
    name: 'OldNew',
    component: OldNew,
    meta: {
      title: '新老昆通卡'
    }
  },
  {
    path: '/gonggaoList',
    name: 'GonggaoList',
    component: GonggaoList,
    meta: {
      title: '公告'
    }



  },
  {
    path: '/inforList',
    name: 'InforList',
    component: InforList,
    meta: {
      title: '信息列表'
    }
  },

  {
    path: '/fankui',
    name: 'Fankui',
    component: Fankui,
    meta: {
      title: '反馈'
    }
  },
  {
    path: '/fankuiTips',
    name: 'FankuiTips',
    component: FankuiTips,
    meta: {
      title: '反馈提示'
    }
  },
  {
    path: '/byCarUseHelp',
    name: 'ByCarUseHelp',
    component: ByCarUseHelp,
    meta: {
      title: '乘车帮助'
    }
  },
  {
    path: '/IDcard',
    // redirect: '/Weihu',
    name: 'IDcard',
    component: IDcard,
    meta: {
      title: '身份证'
    }
  },
  {
    path: '/hukou',
    name: 'Hukou',
    // redirect: '/Weihu',
    component: () => import( /* webpackChunkName: "about" */ '../views/Hukou.vue'),
    meta: {
      title: '居民户口簿'
    }
  },
  {
    path: '/Jiashizhen',
    name: 'Jiashizhen',
    // redirect: '/Weihu',
    component: () => import( /* webpackChunkName: "about" */ '../views/Jiashizhen.vue'),
    meta: {
      title: '驾驶证'
    }
  },
  {
    path: '/Marry',
    name: 'Marry',
    // redirect: '/Weihu',
    component: () => import( /* webpackChunkName: "about" */ '../views/Marry.vue'),
    meta: {
      title: '婚姻证'
    }
  },
  {
    path: '/Canbao',
    name: 'Canbao',
    // redirect: '/Weihu',
    component: () => import( /* webpackChunkName: "about" */ '../views/Canbao.vue'),
    meta: {
      title: '个人参保证明'
    }
  },
  {
    path: '/TeacherCard',
    name: 'TeacherCard',
    // redirect: '/Weihu',
    component: () => import( /* webpackChunkName: "about" */ '../views/TeacherCard.vue'),
    meta: {
      title: '教师资格证'
    }
  },
  {
    path: '/JuzhuCard',
    name: 'JuzhuCard',
    // redirect: '/Weihu',
    component: () => import( /* webpackChunkName: "about" */ '../views/JuzhuCard.vue'),
    meta: {
      title: '居住证'
    }
  },

  {
    path: '/Road',
    // redirect: '/Weihu',
    name: 'Road',
    component: () => import( /* webpackChunkName: "about" */ '../views/Road.vue'),
    meta: {
      title: '道路运输经营许可证'
    }
  },
  {
    path: '/Xingshi',
    name: 'Xingshi',
    // redirect: '/Weihu',
    component: () => import( /* webpackChunkName: "about" */ '../views/Xingshi.vue'),
    meta: {
      title: '行驶证'
    }
  },
  {
    path: '/Yinye',
    name: 'Yinye',
    // redirect: '/Weihu',
    component: () => import( /* webpackChunkName: "about" */ '../views/Yinye.vue'),
    meta: {
      title: '营业执照'
    }
  },
  {
    path: '/GonggaoListDetail',
    name: 'GonggaoListDetail',
    component: () => import( /* webpackChunkName: "about" */ '../views/GonggaoListDetail.vue'),
    meta: {
      title: '公告详情'
    }
  },
  {
    path: '/NewPatch',
    name: 'NewPatch',
    component: NewPatch,
    meta: {
      title: '版本'
    }
  },
  {
    path: '/Authercitation',
    name: 'Authercitation',
    component: Authercitation,
    meta: {
      title: '实名认证'
    }
  },

  {
    path: '/Saoyisao',
    name: 'Saoyisao',
    component: Saoyisao,
    meta: {
      title: '下载'
    }
  },
  {
    path: '/Injiaotong',
    name: 'Injiaotong',
    component: () => import( /* webpackChunkName: "about" */ '../views/Injiaotong.vue'),
    meta: {
      title: '交通出行详情'
    }
  },
  {
    path: '/InjiaotongShare',
    name: 'InjiaotongShare',
    component: () => import( /* webpackChunkName: "about" */ '../views/InjiaotongShare.vue'),
    meta: {
      title: '交通出行详情'
    }
  },


  {
    path: '/ChangeInfor',
    name: 'ChangeInfor',
    component: ChangeInfor,
    meta: {
      title: '修改信息'
    }
  },
  {
    path: '/ChangeAddr',
    name: 'ChangeAddr',
    component: ChangeAddr,
    meta: {
      title: '修改地址'
    }

  },
  {
    path: '/ZhenjianView',
    name: 'ZhenjianView',
    component: () => import( /* webpackChunkName: "about" */ '../views/ZhenjianView.vue'),
    meta: {
      title: '查看证件'
    }

  },

  {
    path: '/Map1',
    name: 'Map1',
    component: Map1,
    meta: {
      title: '地图'
    }

  },
  {
    path: '/Map2',
    name: 'Map2',
    component: Map2,
    meta: {
      title: '地图'
    }

  },
  {
    path: '/Map3',
    name: 'Map3',
    component: Map3,
    meta: {
      title: '地图'
    }

  },

  {
    path: '/HukouView',
    name: 'HukouView',
    // redirect: '/Weihu',
    component: HukouView,
    meta: {
      title: '查看证件'
    }

  },

  {
    path: '/Fangchan',
    name: 'Fangchan',
    // redirect: '/Weihu',
    component: Fangchan,
    meta: {
      title: '不动产(房产证)'
    }

  },
  {
    path: '/ChongzhiTips',
    name: 'ChongzhiTips',
    component: ChongzhiTips,
    meta: {
      title: '充值成功'
    }

  },

  {
    path: '/ShareHudong',
    name: 'ShareHudong',
    component: () => import( /* webpackChunkName: "about" */ '../views/ShareHudong.vue'),
    meta: {
      title: '互动分享'
    }
  },
  {
    path: '/AdministrativeNotice',
    name: 'AdministrativeNotice',
    component: () => import( /* webpackChunkName: "about" */ '../views/AdministrativeNotice.vue'),
    meta: {
      title: '政务公告'
    }
  },
  {
    path: '/newPage/:NewsId',
    name: 'NewPage',
    props: true,
    component: () => import( /* webpackChunkName: "about" */ '../views/NewPage.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/myIntergral',
    name: 'MyIntergral',
    props: true,
    component: () => import( /* webpackChunkName: "about" */ '../views/MyIntergral/MyIntergral.vue'),
    meta: {
      title: '我的积分'
    }
  },

  {
    path: '/integral_rule',
    name: 'IntegralRule',
    props: true,
    component: IntegralRule,
    meta: {
      title: '积分规则'
    }
  },


]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  // if (to.matched.length === 0) { //如果未匹配到路由
  //   from.name ? next({
  //     name: from.name
  //   }) : next('/CuowuPage'); //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  // } else {
  //   next(); //如果匹配到正确跳转
  // }

  let token = to.query.token
  if (token && token !== "") {
    localStorage.setItem("token", token);
  }
  next()
})





export default router